import type { IMoodRecord } from '@shared/types';
import { formatMoodDate } from '../../lib/moodUtils/formatMoodDate';
import { getMoodUI } from '../../lib/moodUtils/getMoodUIDetails';
import { clx } from '../../lib/utils';

interface IMoodLogListProps {
  isLoading: boolean;
  moodRecords: IMoodRecord[];
}
export const MoodLogList = ({ moodRecords, isLoading }: IMoodLogListProps) => {
  // console.log(`%cMoodLogList rendered`, 'background:orange; color:black;');
  if (isLoading) {
    // @TODO: show skeleton.
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col gap-3 p-4">
      <h1> HOME PAGE: mood log list</h1>
      {moodRecords.map((record) => {
        const { faceEmoji, bgColor } = getMoodUI(record.label_mood);
        const formattedDate = formatMoodDate(record.mood_date);

        return (
          <button
            key={record.id}
            className={clx(
              bgColor,
              'flex w-full items-center gap-4 rounded-xl px-4 py-3',
              'h-16 drop-shadow'
            )}
          >
            <div className="shrink-0 scale-50">{faceEmoji}</div>
            <div className="flex-1 text-left">
              <div className="text-sm text-gray-600">{formattedDate}</div>
              <div className="text-lg font-semibold">{record.label_mood}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
